import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function ThankYou() {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/");
    }, 3000); // presmeruje po 3 sekundách
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <section className="thankyou-section">
      <h2>Ďakujeme za správu!</h2>
      <p>Vaša správa bola úspešne odoslaná.<br />Budete presmerovaní na hlavnú stránku.</p>
    </section>
  );
}